import { PriceWatcher } from '@module/PriceWatcher/PriceWatcher';
import { documentReady } from '@js/utils/toolbox';

documentReady(() => {
	PriceWatcher.init();
});
